<script setup>
import { ref, onMounted } from 'vue'
import { authentication, api } from '@dpgradio/creative'

const TOGGLE_NAME = 'mvm-26'

const subscribed = ref(false)
const loading = ref(false)
const error = ref(null)

onMounted(async () => {
  if (!authentication.isLoggedIn()) return

  try {
    const result = await api.request().get(`/members/me/toggles/${TOGGLE_NAME}`)
    subscribed.value = result?.toggled === true
  } catch {
    // Not logged in or API failed — show as unsubscribed
  }
})

async function subscribe() {
  if (subscribed.value || loading.value) return

  loading.value = true
  try {
    await authentication.require()
    await api.request().post(`/members/me/toggles?name=${TOGGLE_NAME}`)
    subscribed.value = true
  } catch (e) {
    // User cancelled login or API failed
    error.value = e.message || String(e)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <button class="opt-in" :class="{ subscribed, loading }" :disabled="subscribed || loading" @click="subscribe">
    <svg v-if="subscribed" class="opt-in-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
      <polyline points="20 6 9 17 4 12" />
    </svg>
    <svg v-else class="opt-in-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
    <span>{{
      error ? error : subscribed ? 'We laten je weten wanneer er updates zijn' : 'Houd mij op de hoogte'
    }}</span>
  </button>
</template>

<style scoped>
.opt-in {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 2rem;
  color: #fff;
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  backdrop-filter: blur(8px);
  transition: background 0.2s;
}

.opt-in:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.85);
}

.opt-in.subscribed {
  background: rgba(0, 0, 0, 0.5);
  cursor: default;
}

.opt-in.loading {
  opacity: 0.7;
  cursor: wait;
}

.opt-in-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
</style>
